<p-dialog
	#dialog
	data-cy="modal-alterar-alcance"
	id="alterar_alcance"
	header="Avaliação Institucional"
	[(visible)]="exibir"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
	class="auto-refresh"
	(onHide)="esconderModal()"
	[closeOnEscape]="false"
	[closable]="false"
	[focusOnShow]="false"
	[autoZIndex]="false"
	[style]='{"z-index":"999999 !important", "width": "400px", "height": "300px"}'
>
	<form [formGroup]="form">
		<sigepe-alert-messages #msg onlyFor="msgAlcance"></sigepe-alert-messages>
		<div class="br-card my-1">
			<div class="card-content">
				<div class="row">
					<div class="col-sm-5 mt-2 br-input">
						<label for="val-alcance" class="mb-2 block font-bold">Alcance (%):</label>
						<p-inputNumber
							id="val-alcance"
							inputStyleClass="text-right"
							formControlName="alcance"
							mode="decimal"
							[step]="1"
							[showButtons]="false"
							[minFractionDigits]="2"
							[maxFractionDigits]="2"
						></p-inputNumber>
						<sgp-message-feedback
							mensagem="O alcance deve ser um número de 1 a 100."
							data-cy="erro-alcance-obrigatorio"
							[show]="(form.controls['alcance'].errors?.['max'] || form.controls['alcance'].errors?.['min']) && submetido"
						/>
					</div>
				</div>
			</div>
		</div>

		<div class="text-center">
			<button id="botao-salvar" data-cy="botao-salvar" class="br-button primary mr-2" (click)="salvar()" type="button" pButton>
				Salvar
			</button>
			<button id="botao-fechar" data-cy="botao-fechar" class="br-button mr-2" (click)="esconderModal()" type="button" pButton>
				Fechar
			</button>
		</div>
	</form>
</p-dialog>
